import { __decorate } from "tslib";
import { Component, Mixins } from "vue-property-decorator";
import Loader from "@/components/widgets/loader.vue";
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import teamSave, { TeamSaveModel } from "@/store/models/teams/addTeam";
import { toaster } from "@/utilities/toaster";
import TeamModule from "@/store/modules/team.module";
let AddTeam = /** @class */ (() => {
    let AddTeam = class AddTeam extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            // DATA
            this.team = new teamSave(new TeamSaveModel());
            this.title = "Add Team";
            this.ctaButtons = [
                {
                    routeName: "Teams",
                },
            ];
            this.items = [
                {
                    text: "Home",
                    href: "#",
                },
                {
                    text: "Teams",
                    href: "#",
                },
                {
                    text: "Add Team",
                    active: true,
                },
            ];
        }
        saveTeam() {
            this.validate("addTeamObserver").then((res) => {
                if (res) {
                    TeamModule.saveTeam(this.team).then((res) => {
                        if (res) {
                            toaster.ShowSuccess(`Team was created successfully.`);
                            this.$router.push({ name: "Teams" });
                        }
                        else {
                            toaster.ShowError("Team Name already exists.");
                        }
                    });
                }
            });
        }
    };
    AddTeam = __decorate([
        Component({
            name: "TeamsListing",
            components: {
                Layout,
                PageHeader,
                Loader,
            },
        })
    ], AddTeam);
    return AddTeam;
})();
export default AddTeam;
